module.exports = __webpack_public_path__ + "img/05_blue_dance.893f788e.gif";